export type LangPath<T> = {
	[P in keyof T]: LangPath<T[P]>;
}

export function genLangPaths<T>(source: T, path: string[] = []): LangPath<T> {
	const hash: LangPath<T> = Object.create({});
	Object.keys(source).forEach(key => {
		const value = source[key];
		const current = [...path, key];
		hash[key] = (typeof value === "string")
			? current.join(".")
			: genLangPaths(value, current);
	});
	return hash;
}